import type { MoneyAutomationFeatureConfig } from './type';

export const moneyAutomationFeatureConfig: MoneyAutomationFeatureConfig = {
    roundUpSavings: {
        signingEndpoint: 'auth/operation/sign/',
        localStoreProductUri: '',
    },
};
